import React, { useState } from "react";

import { ProductFeatureModel } from "@api/mappers/products.mapper";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { FeatureKind } from "lib/@types/service/product/shared";

import { Feature } from "../feature/feature.component";

type FeatureSectionProps = {
    featureKind: FeatureKind;
    featuresGroupedPerKind: Map<string, ProductFeatureModel[]>;
    maxVisibleFeatures: number;
};

const FeatureSection = ({
    featureKind,
    featuresGroupedPerKind,
    maxVisibleFeatures,
}: FeatureSectionProps) => {
    const { t } = useGranite();

    const [shouldLimit, setShouldLimit] = useState(true);

    const featureKindFeatureList =
        featuresGroupedPerKind.get(featureKind.code) || [];

    const isSizeAboveMaxCount =
        featureKindFeatureList.length > maxVisibleFeatures;

    return (
        <section className="feature-list-component mb-3">
            <div className="col-12 border-bottom border-primary">
                <div className="py-2 font-weight-bold">{featureKind.name}</div>
            </div>

            <div className="feature-list-component__list">
                {featureKindFeatureList
                    .slice(0, shouldLimit ? maxVisibleFeatures : 999)
                    .map((feature, index) => (
                        <Feature
                            key={`${feature.code}-${index}`}
                            feature={feature}
                            featureKind={featureKind}
                        />
                    ))}
            </div>
            {isSizeAboveMaxCount && (
                <div className="feature-list-component__button col-12 my-2">
                    <Button
                        type="button"
                        color="link"
                        onClick={() => setShouldLimit(state => !state)}
                        className="p-0"
                    >
                        {shouldLimit
                            ? t("productDetail.featureList.link.showMore")
                            : t("productDetail.featureList.link.showLess")}{" "}
                        <i
                            className={`las la-angle-${
                                shouldLimit ? "down" : "up"
                            } ml-1`}
                        ></i>
                    </Button>
                </div>
            )}
        </section>
    );
};

export { FeatureSection };
